import { useEffect, useState } from "react";
import { Stars } from "./Stars";
import { api } from "../lib/api";

export function TestimonialsSection() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/testimonials").then(({ data }) => setItems(data || [])).catch(() => setItems([]));
    }, []);
    if (!items.length) return null;
    return (
        <section className="bg-ivory py-16 lg:py-24" data-testid="testimonials-section">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
                <div className="text-center max-w-2xl mx-auto">
                    <span className="label-eyebrow">Whispers from clients</span>
                    <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl text-inkDark tracking-tight">A boutique loved across India</h2>
                </div>
                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-7">
                    {items.map((t) => (
                        <figure key={t.id} className="bg-beige rounded-2xl p-6 flex flex-col gap-5 shadow-soft" data-testid={`testimonial-${t.id}`}>
                            <Stars rating={t.rating} size={14} />
                            <blockquote className="font-serif text-lg text-inkDark leading-snug">
                                &ldquo;{t.body}&rdquo;
                            </blockquote>
                            <figcaption className="mt-auto flex items-center gap-3 pt-3 border-t border-inkDark/10">
                                {t.avatarUrl ? <img src={t.avatarUrl} alt="" className="w-10 h-10 rounded-full" /> : null}
                                <div>
                                    <div className="text-inkDark font-medium">{t.authorName}</div>
                                    {t.authorRole ? <div className="text-xs text-inkMuted">{t.authorRole}</div> : null}
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
